import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dialog from 'dialog-component';
import DialogContent from 'dialog-content-component';

class DidYouMeanDialog extends Component {
    constructor(props) {
        super(props);

        this._onResultSelected = this._onResultSelected.bind(this);
    }

    _onResultSelected(result) {
        this._dialog.hide(result);
    }

    render() {
        const {
            className,
            results,
            onHidden
        } = this.props;
        const classes = classNames(
            'DidYouMeanDialog',
            className
        );
        const hasResults = (results.length > 0);
        const title = (hasResults) ? 'Multiple Addresses Found' : 'No Address Found';

        return (
            <Dialog
                className={classes}
                title={title}
                onHidden={onHidden}
                ref={node => { this._dialog = node; }}
            >
                <DialogContent>
                    {!hasResults &&
                        <p>Please try again using a different address.</p>
                    }
                    {hasResults &&
                        <span>
                            <h2 className="heading-md">Which one do you want?</h2>
                            <div className="List-row">
                                {results.map(result => {
                                    return (
                                        <button
                                            key={result.formatted_address}
                                            onClick={evt => {
                                                this._onResultSelected(result);
                                            }}
                                        >
                                            {result.formatted_address}
                                        </button>
                                    );
                                })}
                            </div>
                        </span>
                    }
                </DialogContent>
            </Dialog>
        );
    }
}

DidYouMeanDialog.propTypes = {
    className: PropTypes.string,
    results: PropTypes.array.isRequired,
    onHidden: PropTypes.func.isRequired
};

export default DidYouMeanDialog;



// WEBPACK FOOTER //
// ./spothero/static/main/js/search/components/common/DidYouMeanDialog.jsx